module.exports = __webpack_public_path__ + "static/img/bottomFix.9afbd22.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/bottomfix/bottomFix.png
// module id = zuiZ
// module chunks = 0